<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-07-02 15:30:20
 -->
<template>
  <div class="ape-container" :style="{backgroundImage: 'url('+this.mxDomain.backgroundImg+')'}">
    <router-view />
    <Footer :tag="tag"/>
  </div>
</template>
<script>
import Footer from './Footer'
export default {
  components: {
    Footer,
  },
  data(){
    return {
      tag: true
    }
  },
  created() {
    console.log()
  },
}
</script>

<style lang="stylus">
  $screen-md-min = 768px
  $heading-color = rgba(0, 0, 0, 0.85)
  $font-size-base = 14px
  $text-color-secondary = rgba(0, 0, 0, 0.45)
  .ape-container
    display flex
    height 100vh
    overflow hidden
    align-items center
    background-size cover
</style>


